import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'api/axios';

const initialState = {
	currentOpenDrawer: '',
	message: '',
	mainProductCategoryId: '',
	subCategoryId: '',
	mainProductCategories: [],
	productynamicFields: [],
	productSubCategory: [],
	isLoading: false,
	drawarLoading: false,
	pagination: {
		page: 1,
		limit: 10,
		totalPages: 0,
		totalResults: 0,
	},
	drawerValues: {
		CREATE_DYNAMIC_FIELD: 'CREATE_DYNAMIC_FIELD',
		UPDATE_DYNAMIC_FIELD: 'UPDATE_DYNAMIC_FIELD',
		FILTER_DYNAMIC_FIELD: 'FILTER_DYNAMIC_FIELD',
		VIEW_DYNAMIC_FIELD: 'VIEW_DYNAMIC_FIELD',
	},
};

// Product Main Category CRUD
export const getAllMainProductCategories = createAsyncThunk('productCategory/getAllMainProductCategories', async (options, { rejectWithValue }) => {
	try {
		const query = new URLSearchParams(options).toString();

		const response = await axiosInstance.get(`/category/admin?${query}`);
		if (response.success) {
			return response;
		}

		rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const addNewMaincategory = createAsyncThunk('productCategory/addNewMaincategory', async (data, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.post(`/category`, data);
		console.log(response, 'response');

		if (response.success) {
			const { productCategory } = getState();

			const options = {
				page: productCategory.pagination.page,
				limit: productCategory.pagination.limit,
			};

			dispatch(getAllMainProductCategories(options));
			return response;
		}

		rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const deleteMainCategory = createAsyncThunk('productCategory/deleteMainCategory', async (id, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.delete(`/category/${id}`);

		if (response.success) {
			const { productCategory } = getState();

			const options = {
				page: productCategory.pagination.page,
				limit: productCategory.pagination.limit,
			};

			dispatch(getAllMainProductCategories(options));
			return response;
		}
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const updateMainCategory = createAsyncThunk('productCategory/updateMainCategory', async ({ id, data }, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.patch(`/category/${id}`, data);

		if (response.success) {
			const { productCategory } = getState();

			const options = {
				page: productCategory.pagination.page,
				limit: productCategory.pagination.limit,
			};

			dispatch(getAllMainProductCategories(options));
			return response;
		}
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

// Product Sub Category CRUD
export const getAllSubProductCategories = createAsyncThunk('productCategory/getAllSubProductCategories', async (options, { rejectWithValue }) => {
	try {
		const query = new URLSearchParams(options).toString();

		const response = await axiosInstance.get(`/sub-category/admin?${query}`);
		if (response.success) {
			return response;
		}

		rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const createSubCategory = createAsyncThunk('productCategory/createNewSubCategory', async (data, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.post(`/sub-category`, data);

		if (response.success) {
			const { productCategory } = getState();

			const options = {
				categoryId: productCategory.mainProductCategoryId,
				page: productCategory.pagination.page,
				limit: productCategory.pagination.limit,
			};

			dispatch(getAllSubProductCategories(options));
			return response;
		}
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const updateSubCategory = createAsyncThunk('productCategory/updateSubCategory', async ({ id, data }, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.patch(`/sub-category/${id}`, data);

		if (response.success) {
			const { productCategory } = getState();

			const options = {
				categoryId: productCategory.mainProductCategoryId,
				page: productCategory.pagination.page,
				limit: productCategory.pagination.limit,
			};

			dispatch(getAllSubProductCategories(options));
			return response;
		}
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const deleteSubCategory = createAsyncThunk('productCategory/deleteSubCategory', async (id, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.delete(`/sub-category/${id}`);

		if (response.success) {
			const { productCategory } = getState();

			const options = {
				categoryId: productCategory.mainProductCategoryId,
				page: productCategory.pagination.page,
				limit: productCategory.pagination.limit,
			};

			dispatch(getAllSubProductCategories(options));
			return response;
		}
	} catch (error) {
		console.error(error.response, 'ERR...');
		return rejectWithValue(error.response || 'Error');
	}
});

// Product Dynamic Fields CRUD

export const getAllDynamicFields = createAsyncThunk('productCategory/getAllDynamicFields', async (options, { rejectWithValue }) => {
	try {
		const query = new URLSearchParams(options).toString();

		const response = await axiosInstance.get(`/category-fields/admin?${query}`);
		if (response.success) {
			return response;
		}

		rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);

		return rejectWithValue(error.response || {});
	}
});

export const createProductDynamicField = createAsyncThunk('productCategory/createProductDynamicField', async (data, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.post(`/category-fields`, data);

		if (response.success) {
			const { productCategory } = getState();

			const options = {
				categoryId: productCategory.mainProductCategoryId,
				subCategoryId: productCategory.subCategoryId,
				allRecords: true,
				page: productCategory.pagination.page,
				limit: productCategory.pagination.limit,
			};

			dispatch(updateDrawerView(''));
			dispatch(getAllDynamicFields(options));
			return response;
		}
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const updateDynamicField = createAsyncThunk('productCategory/updateDynamicField', async ({ id, data }, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.patch(`/category-fields/${id}`, data);

		if (response.success) {
			const { productCategory } = getState();

			const options = {
				categoryId: productCategory.mainProductCategoryId,
				subCategoryId: productCategory.subCategoryId,
				allRecords: true,
				page: productCategory.pagination.page,
				limit: productCategory.pagination.limit,
			};

			dispatch(updateDrawerView(''));
			dispatch(getAllDynamicFields(options));
			return response;
		}
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const deleteDynamicField = createAsyncThunk('productCategory/deleteDynamicField', async (id, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.delete(`/category-fields/${id}`);

		if (response.success) {
			const { productCategory } = getState();

			const options = {
				categoryId: productCategory.mainProductCategoryId,
				subCategoryId: productCategory.subCategoryId,
				allRecords: true,
				page: productCategory.pagination.page,
				limit: productCategory.pagination.limit,
			};

			dispatch(getAllDynamicFields(options));
			return response;
		}
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const productCategorySlice = createSlice({
	name: 'productCategory',
	initialState: initialState,
	reducers: {
		setLoading: (state, action) => {
			state.isLoading = action.payload;
		},
		updatePagination: (state, action) => {
			state.pagination = {
				...state.pagination,
			};
		},
		setMainProductCategoryId: (state, action) => {
			state.mainProductCategoryId = action.payload;
		},
		setSubCategoryId: (state, action) => {
			state.subCategoryId = action.payload;
		},
		updateDrawerView: (state, action) => {
			state.currentOpenDrawer = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getAllMainProductCategories.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(getAllMainProductCategories.fulfilled, (state, { payload }) => {
				state.mainProductCategories = payload.result.data;
				state.message = payload.message;
				state.isLoading = false;
				state.pagination = {
					page: payload.result.page,
					limit: payload.result.limit,
					totalPages: payload.result.totalPages,
					totalResults: payload.result.totalResults,
				};
			})
			.addCase(getAllMainProductCategories.rejected, (state, { payload }) => {
				state.mainProductCategories = [];
				state.message = '';
				state.isLoading = false;
			})
			.addCase(addNewMaincategory.pending, (state, { payload }) => {
				state.drawarLoading = true;
			})
			.addCase(addNewMaincategory.fulfilled, (state, { payload }) => {
				state.drawarLoading = false;
				state.message = payload.message;
			})
			.addCase(addNewMaincategory.rejected, (state, { payload }) => {
				state.drawarLoading = false;
				state.message = payload.message;
			})
			.addCase(deleteMainCategory.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(deleteMainCategory.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(deleteMainCategory.rejected, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(updateMainCategory.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(updateMainCategory.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(updateMainCategory.rejected, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(getAllSubProductCategories.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(getAllSubProductCategories.fulfilled, (state, { payload }) => {
				state.productSubCategory = payload.result.data;
				state.message = payload.message;
				state.isLoading = false;
				state.pagination = {
					page: payload.result.page,
					limit: payload.result.limit,
					totalPages: payload.result.totalPages,
					totalResults: payload.result.totalResults,
				};
			})
			.addCase(getAllSubProductCategories.rejected, (state, { payload }) => {
				state.productSubCategory = [];
				state.message = '';
				state.isLoading = false;
			})
			.addCase(deleteSubCategory.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(deleteSubCategory.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(deleteSubCategory.rejected, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(createSubCategory.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(createSubCategory.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(createSubCategory.rejected, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(createProductDynamicField.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(createProductDynamicField.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(createProductDynamicField.rejected, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(getAllDynamicFields.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(getAllDynamicFields.fulfilled, (state, { payload }) => {
				state.productynamicFields = payload.result.data;
				state.message = payload.message;
				state.isLoading = false;
				state.pagination = {
					page: payload.result.page,
					limit: payload.result.limit,
					totalPages: payload.result.totalPages,
					totalResults: payload.result.totalResults,
				};
			})
			.addCase(getAllDynamicFields.rejected, (state, { payload }) => {
				state.productynamicFields = [];
				state.message = '';
				state.isLoading = false;
			})
			.addCase(deleteDynamicField.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(deleteDynamicField.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(deleteDynamicField.rejected, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			});
	},
});

export const { updatePagination, setMainProductCategoryId, setSubCategoryId, updateDrawerView } = productCategorySlice.actions;

export default productCategorySlice.reducer;
